module.exports = __webpack_public_path__ + "img/shot_bigtx10.141bad54.png";